module.exports = __webpack_public_path__ + "static/media/white-google-play.70100717.png";